import { createRoot } from "react-dom/client";
import { App } from "@/app/index";
import { BrowserRouter } from "react-router-dom";
import { StrictMode } from "react";
import { Provider } from "react-redux";
import { store } from "./app/appStore";
import { AppProviders } from "./app/AppProviders";

const root = document.getElementById("root");

if (!root) {
  throw new Error("root not found");
}

const container = createRoot(root);
if (__ISPROD__) {
  console.log = function () {};
}

container.render(
  <StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <AppProviders>
          <App />
        </AppProviders>
      </Provider>
    </BrowserRouter>
  </StrictMode>,
);
